export default __webpack_public_path__ + "static/media/graph.0cc4d383.svg";